
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1702|8886)0$/.test(chunkId);
},
rootOutputDir: "",

    };
}
